import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Link,
  Box,
  Typography,
  List,
  ListItem,
  Tab,
  Tabs,
  Button,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Slider from "@mui/material/Slider";
import Historical from "../Historical";
import NewCalculatorv6 from "./NewCalculatorV6";
import NewCalculatorv8 from "./NewCalculatorV8";
import AdvanceCalculator from "./AdvanceCalculator";
import cookie from "js-cookie";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { enquireNowGTMCTAClick } from "../../util/gtmutil";
import auth from "../Layout/util/auth";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
    title: {
      display: false,
      text: "Chart.js Bar Chart",
    },
  },
};

const labels = ["Return on Investment"];

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    display: "block",
    minHeight: "100vh",
    padding: "0 15px",
    background: "rgba(48, 39, 72, 0.9)",
    "@media(max-width:767px)": {
      padding: "0",
    },
  },
  bannerContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    padding: "55px 72px",
    margin: "auto",
    alignItems: "center",
    justifyContent: "center",
    "@media(max-width:480px)": {
      padding: "0px 0 0px",
    },
  },
  bannerImageContainer: {
    width: "100%",
    "@media(max-width:767px)": {
      padding: "0",
    },
  },
  investmentBox: {
    position: "relative",
    display: "block",
    background: "#19132A",
    backdropFilter: "blur(74px)",
    borderRadius: "24px",
    padding: "20px 25px 9px",
    width: "100%",
    maxWidth: "360px",
    margin: "auto",
    "& p": {
      color: "#fff",
      fontSize: "14px",
      fontWeight: "500",
      marginBottom: "0",
      textAlign: "left",
    },
    "& > img": {
      marginBottom: "25px",
    },
  },
  amount: {
    color: "#fff !important",
    fontSize: "16px",
    paddingLeft: "3px",
    cursor: "pointer",
    textDecoration: "none",
  },
  amountLg: {
    color: "#E14084",
    fontSize: "74px",
    fontWeight: "500",
    "& span": {
      color: "#fff",
      fontSize: "34px",
      fontWeight: "500",
    },
  },
  thumbCardBox: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "46px",
    "& img": {
      width: "70px",
      height: "70px",
      borderTadius: "4px",
      objectFit: "cover",
      margin: "auto",
      display: "block",
    },
  },
  slider: {
    width: "100%",
    position: "relative",
    display: "block",
    margin: "0 auto 15px",
    borderRadius: "10px",
    padding: "10px 0",
    "& .MuiSlider-thumb": {
      background: "#fff",
      borderRadius: "4px",
      minWidth: "20px",
      height: "20px",
      color: "#000",
      "&:after": {
        display: "none !important",
      },
      "&:hover": {
        boxShadow: "none",
      },
    },
    "& .MuiSlider-root": {
      height: "2px",
      marginBottom: "0",
    },
    "& .MuiSlider-track": {
      background: "#E94177",
      border: "none",
    },
    "& .MuiSlider-rail": {
      background: "#fff",
    },
    "& .MuiSlider-valueLabel": {
      position: "relative",
      transform: "none !important",
      top: "0",
      padding: "4px",
      fontSize: "10px",
      color: "#000",
      background: "#fff",
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-markLabel": {
      color: "rgba(255, 255, 255, 0.7)",
      fontSize: "10px",
    },
    "@media(max-width:480px)": {
      margin: "0 auto 0",
      padding: "0",
      "& .MuiSlider-markLabel": {
        top: "25px",
      },
    },
  },
  dropDownContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "20px",
    "& img": {
      marginLeft: "2px",
    },
    "&:first-of-type": {
      marginBottom: "20px",
    },
    "@media(max-width:480px)": {
      marginBottom: "0",
      "&:first-of-type": {
        marginBottom: "5px",
      },
    },
  },
  amountDropdown: {
    position: "relative",
    display: "block",
    width: "140px",
    background: "#242033",
    borderRadius: "12px",
    padding: "15px",
    "& li": {
      position: "relative",
      display: "block",
      padding: "5px 0",
      "& label": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        justifyContent: "space-between",
      },
      "& p": {
        fontSize: "14px",
        fontWeight: "400",
        color: "#fff",
      },
      "& input": {
        "-webkit-appearance": "none",
        width: "16px",
        height: "16px",
        "&:checked": {
          background:
            "center/contain no-repeat url(/images/token/pink-tick.svg)",
        },
      },
    },
  },
  tabContainer: {
    display: "flex",
    position: "relative",
    width: "100%",
    margin: "auto",
    marginBottom: "30px",
    border: "1px solid #fff",
    borderRadius: "8px",
    "& .Mui-selected": {
      color: "#000 !important",
      background: "#fff",
    },
    "& .MuiTabs-flexContainer": {
      width: "100%",
      "& button": {
        width: "50%",
        textTransform: "capitalize",
        color: "#fff",
        fontSize: "14px",
      },
    },
    "@media(max-width:480px)": {
      marginBottom: "10px",
    },
  },
  tabDescription: {
    color: "#fff",
    fontSize: "24px",
    width: "100%",
    position: "relative",
    display: "block",
    marginTop: "20px",
  },
  tab: {
    color: "#fff",
    fontSize: "20px",
    textTransform: "capitalize",
    "&:focus": {
      outline: "none",
    },
    "@media (max-width: 480px)": {
      // maxWidth: "110px",
      fontSize: "16px",
    },
  },
  barGraph: {
    color: "rgba(255,255,255,0.5)",
    background: "#2d2444",
    padding: "5px",
    borderRadius: "10px",
    "& canvas": {
      height: "250px !important",
      pointerEvents: "none",
    },
    "@media(max-width:480px)": {
      marginTop: "10px",
    },
  },
  royaltyShare: {
    "& #royalty-share-popover .MuiPaper-root": {
      background: "none !important",
    },
  },
  btnAdvanceCalculator: {
    position: "relative",
    display: "block",
    marginBottom: "30px",
    "& button": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "8.5px 0",
      border: "1px solid #fff",
      borderRadius: "8px",
      color: "#fff",
    },
  },
}));

function valueLabelFormat(value) {
  return `${value}mn`;
}
function valueLabelFormat2(value) {
  return `₹${value}`;
}

const marks = [
  {
    value: 0,
    label: "1mn",
  },
  {
    value: 1000,
    label: "1B",
  },
];
function valuetext(value) {
  return `${value}mn`;
}

const marks2 = [
  {
    value: 0.01,
    label: "₹0.01",
  },
  {
    value: 0.05,
    label: "₹0.05",
  },
];
function valuetext2(value) {
  return `$${value}`;
}

export default function Index(props) {
  const tierData = props?.tierData?.asset_tiers?.data;
  const {
    version = false,
    historicalCalc = false,
    historicalCategory = "Punjabi_Indie",
    defaultStream = defaultStream || 200,
    defaultNft = defaultNft,
    is_tradable = false,
  } = props;

  const [slidervalue, setSliderValue] = React.useState(200);
  const handleChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  const [slidervalue2, setSliderValue2] = React.useState(0.04);
  const handleChange2 = (event, newValue) => {
    setSliderValue2(newValue);
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const [openRoyalty, setOpenRoyalty] = useState(false);
  const handleClose2 = () => {
    setOpenRoyalty(false);
  };
  const handleOpen2 = () => {
    setOpenRoyalty(true);
  };

  const [value, setValue] = React.useState(historicalCalc ? 1 : 0);
  const handleTabs = (e, val) => {
    setValue(val);
  };

  useEffect(() => {
    console.log("slide value", slidervalue);
  }, [slidervalue]);

  const investmentAmounts = [1000, 2000, 3000, 10000, 20000];
  const royaltyShares = [0.01, 0.05, 0.1, 0.2, 0.3, 0.5, 1];
  const [royalty, setRoyalty] = useState(0.1);
  const [investment, setInvestment] = useState(1000);
  const [returnOnInvestment, setReturnOnInvestment] = useState(10000);
  const [calculatorType, setCalculatorType] = useState("BASIC");
  const { userData } = useSelector((state) => state.user);
  const r = auth();
  useEffect(() => {
    let songTotalValue = (investment * 100) / royalty;
    let songtotalEarning = slidervalue * 1000000 * slidervalue2;
    setReturnOnInvestment(
      Math.round((investment * songtotalEarning) / songTotalValue)
    );
  }, [slidervalue, slidervalue2, investment, royalty]);
  let data = {
    labels,
    datasets: [
      {
        label: "Investment",
        data: [investment],
        backgroundColor: "rgba(255,255,255,1)",
      },
      {
        label: "My Return",
        data: [returnOnInvestment],
        backgroundColor: "rgba(52,83,249,1)",
      },
    ],
  };

  const toggleCalculator = () => {
    if (calculatorType == "BASIC") {
      setCalculatorType("ADVANCE");
    } else setCalculatorType("BASIC");
  };

  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.bannerContainer}>
          <Box className={classes.bannerImageContainer}>
            <Box className={classes.investmentBox}>
              <Box
                style={{ cursor: "pointer" }}
                onClick={() => props.closePopup()}
                component="img"
                src="/images/calculator/close.svg"
              />
              <Box className={classes.dropDownContainer}>
                <Tabs
                  TabIndicatorProps={{ style: { background: "transparent" } }}
                  className={classes.tabContainer}
                  value={value}
                  onChange={handleTabs}
                >
                  <Tab
                    label="Calculator"
                    className={classes.tab}
                    onClick={() => {
                      enquireNowGTMCTAClick(
                        r,
                        "ctaClicks",
                        "loggedIn",
                        "Guest",
                        "Calculator",
                        userData?.mobile,
                        userData?.email,
                        cookie.get("_gid")
                      );
                    }}
                  />
                  <Tab
                    label="Historical"
                    className={classes.tab}
                    onClick={() => {
                      enquireNowGTMCTAClick(
                        r,
                        "ctaClicks",
                        "loggedIn",
                        "Guest",
                        "Historical",
                        userData?.mobile,
                        userData?.email,
                        cookie.get("_gid")
                      );
                    }}
                  />
                </Tabs>
                <TabPanel value={value} index={1} style={{ color: "#fff" }}>
                  {" "}
                  <Historical
                    historicalCategory={historicalCategory}
                  ></Historical>
                </TabPanel>
                <TabPanel value={value} index={0} style={{ color: "#fff" }}>
                  {calculatorType == "BASIC" && (
                    <NewCalculatorv6
                      tierData={tierData}
                      defaultStream={defaultStream}
                      defaultNft={defaultNft}
                      is_tradable={is_tradable}
                    ></NewCalculatorv6>
                  )}
                  {calculatorType == "ADVANCE" && !version && (
                    <AdvanceCalculator
                      defaultStream={defaultStream}
                      defaultNft={defaultNft}
                      tierData={props?.tierData}
                      is_tradable={is_tradable}
                      version={version}
                    ></AdvanceCalculator>
                  )}
                  {calculatorType == "ADVANCE" && version && (
                    <NewCalculatorv8
                      tierData={props?.tierData}
                    ></NewCalculatorv8>
                  )}

                  <Box
                    className={classes.btnAdvanceCalculator}
                    onClick={() => toggleCalculator()}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        enquireNowGTMCTAClick(
                          r,
                          "ctaClicks",
                          "loggedIn",
                          "Guest",
                          `${
                            calculatorType == "BASIC" ? "Advance" : "Basic"
                          } CALCULATOR `
                        );
                      }}
                    >
                      {calculatorType == "BASIC" ? "Advance" : "Basic"}{" "}
                      {/* {calculatorType == "BASIC" ? "Basic" : "Advance"}{" "} */}
                      Calculator
                    </Button>
                  </Box>
                  {/* <PopupState variant="popover" popupId="demo-popup-popover">
                    {(popupState) => (
                      <>
                        <Box
                          className={classes.dropDownContainer}
                          {...bindTrigger(popupState)}
                          // onClick={handleOpen}
                        >
                          <Box style={{ width: "100%" }}>
                            <Typography
                              component="p"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              Investment
                              <Link
                                href="#"
                                className={classes.amount}
                                onClick={handleOpen}
                              >
                                ₹{investment}{" "}
                                <Box
                                  component="img"
                                  src="/images/calculator/caret-down.svg"
                                />
                              </Link>
                            </Typography>
                          </Box>
                        </Box>
                        <Popover
                          {...bindPopover(popupState)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          open={open}
                          onClose={handleClose}
                        >
                          <List className={classes.amountDropdown}>
                            {investmentAmounts.map((item, index) => {
                              return (
                                <ListItem
                                  key={index}
                                  onClick={() => {
                                    setInvestment(item);
                                    handleClose();
                                  }}
                                >
                                  <label htmlFor={"amount" + index.toString()}>
                                    <Typography
                                      component="p"
                                      style={{ textAlign: "right" }}
                                    >
                                      ₹{item}
                                    </Typography>
                                    <input
                                      type="radio"
                                      name="amount"
                                      id={"amount" + index.toString()}
                                    />
                                  </label>
                                </ListItem>
                              );
                            })}
                          </List>
                        </Popover>
                      </>
                    )}
                  </PopupState>
                  <PopupState variant="popover" popupId="royalty-share-popover">
                    {(popupState) => (
                      <>
                        <Box
                          className={classes.dropDownContainer}
                          {...bindTrigger(popupState)}
                          // onClick={handleOpen}
                        >
                          <Typography
                            component="p"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            Royalty Share
                            <Link
                              href="#"
                              className={classes.amount}
                              onClick={handleOpen2}
                            >
                              {royalty}%{" "}
                              <Box
                                component="img"
                                src="/images/calculator/caret-down.svg"
                              />
                            </Link>
                          </Typography>
                        </Box>
                        <Popover
                          {...bindPopover(popupState)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          open={openRoyalty}
                          onClose={handleClose2}
                        >
                          <List className={classes.amountDropdown}>
                            {royaltyShares.map((item, index) => {
                              return (
                                <ListItem
                                  key={index}
                                  onClick={() => {
                                    setRoyalty(item);
                                    handleClose2();
                                  }}
                                >
                                  <label htmlFor={"amount" + index.toString()}>
                                    <Typography
                                      component="p"
                                      style={{ textAlign: "right" }}
                                    >
                                      {item}%
                                    </Typography>
                                    <input
                                      type="radio"
                                      name="amount"
                                      id={"amount" + index.toString()}
                                    />
                                  </label>
                                </ListItem>
                              );
                            })}
                          </List>
                        </Popover>
                      </>
                    )}
                  </PopupState>
                  <Box className={classes.slider}>
                    <Typography id="non-linear-slider" gutterBottom>
                      Total Streams
                    </Typography>
                    <Slider
                      value={slidervalue}
                      min={0}
                      step={25}
                      max={1000}
                      defaultValue={5}
                      getAriaValueText={valuetext}
                      valueLabelFormat={valueLabelFormat}
                      onChange={handleChange}
                      valueLabelDisplay="auto"
                      aria-labelledby="non-linear-slider"
                      marks={marks}
                    />
                  </Box>
                  <Box className={classes.slider}>
                    <Typography id="non-linear-slider" gutterBottom>
                      Revenue/Stream
                    </Typography>
                    <Slider
                      value={slidervalue2}
                      min={0.01}
                      step={0.01}
                      max={0.05}
                      defaultValue={3}
                      getAriaValueText={valuetext}
                      valueLabelFormat={valueLabelFormat2}
                      onChange={handleChange2}
                      valueLabelDisplay="auto"
                      aria-labelledby="non-linear-slider"
                      marks={marks2}
                    />
                  </Box>
                  <Box className={classes.barGraph}>
                    <Bar options={options} Color="#fff" data={data} />
                  </Box> */}
                </TabPanel>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
function TabPanel(props) {
  const { children, value, index } = props;
  return <div>{value === index && <h1>{children}</h1>}</div>;
}
